/**
 * Shared TanStack Query singleton for apps/admin.
 *
 * Lives under `shared/` so widgets and module slices can call
 * `queryClient.clear()` on logout (CLAUDE.md FE rule §10) without
 * importing from `app/` — boundaries plugin enforces `fe-widgets →
 * fe-shared` but rejects `fe-widgets → fe-app`.
 *
 * The React provider that wraps the tree with this client lives in
 * `app/providers.tsx` (that file is bootstrap-only and stays in
 * `app/` per ADR frontend-0001).
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
